import React, { useState, useRef } from 'react';
import { uploadFile, getSASToken } from '../../services/azureBlobService.ts';
import LoadingSpinner from '../LoadingSpinner.tsx';
import { v4 as uuidv4 } from 'uuid';
import { triggerOrchestrators, triggerOrchestratorsResponse } from '../../services/azureFunctionAPIs.ts';
import '../../styles/pages/FileUpload.scss';

interface FileUploadProps {
  accessToken: string,
  userName: string,
  userEmail: string
}

const FileUpload: React.FC<FileUploadProps> = (props: FileUploadProps) => {
  const {
    accessToken,
    userName,
    userEmail
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const InputRef = useRef<HTMLInputElement>(null);

  
  const CONTAINER_IMAGE_NAME = process.env.REACT_APP_CONTAINER_IMAGE_NAME ?? "";
  const CONTAINER_FILE_NAME = process.env.REACT_APP_CONTAINER_FILE_NAME ?? "";


  const handleFileChange = (event) => {
    // Check if files are selected
    const maxSize = 10 * 1024 * 1024;
    // Loop through all the selected files
    for (let file of event.target.files) {
      // Check if the file size is greater than 10MB
      if (file.size > maxSize) {
        alert('File size exceeds the limit of 10MB.');
        event.target.value = null; // Reset the input
        return;
      }
    }
    setSelectedFiles(Array.from(event.target.files));
  };

  const handleUpload = async () => {
    // Check if files are selected
    setIsLoading(true);
    // Check if files are selected
    let fileCount = selectedFiles.length;
    if (fileCount === 0) {
      alert('No files selected.');
      setIsLoading(false);
      return;
    }

    let uploadCount = 0;

    // Generate SAS token
    const sasImageTokenGen = await getSASToken(accessToken,CONTAINER_IMAGE_NAME);
    const sasFileTokenGen = await getSASToken(accessToken,CONTAINER_FILE_NAME);
    const uniqueIdImage = uuidv4();
    const uniqueIdFile = uuidv4();
    var imageUploaded = false;
    var fileUploaded = false;
    // Loop through all the selected files
    for (let file of selectedFiles) {
      try {
        var uniqueId;
        var sasTokenGen;
        // Check if the file is an image
        if (file && file.type.startsWith('image/')) {
          uniqueId = uniqueIdImage;
          sasTokenGen =sasImageTokenGen;
          imageUploaded = true;
        } else {
          uniqueId = uniqueIdFile;
          sasTokenGen =sasFileTokenGen;
          fileUploaded = true;
        }

        // Upload the image file
        await uploadFile(file, sasTokenGen, userName, uniqueId)
          .then((response) => {
            //console.log("Response", response);
          })
          .catch((error) => {
            if (error instanceof Error) {
              const { message, stack } = error;
              console.error(
                `Failed to finish upload with error : ${message} ${stack || ''}`
              );
            } else {
              console.error(error as string);
            }
          });
        uploadCount++;
      } catch (error) {
        console.error('Error uploading file:', file, error);
        alert('Error uploading file:' + file + '  ErrorMessage: ' + error);
      }
    }

    //Code Here to call trigger functions
    if (imageUploaded) {
      var response = await triggerOrchestrators("image_recognition", uniqueIdImage, userEmail);
      console.log("Response of image_recognition", response);
      if (response != "") {
        //await triggerOrchestratorsResponse(response);
      }

      console.log("Image Recognition Triggered completed");
    }
    if (fileUploaded) {
      var response = await triggerOrchestrators("text_attributes_matching", uniqueIdFile, userEmail);
      console.log("Response of text_attributes_matching", response);
      if (response != "") {
        //await triggerOrchestratorsResponse(response);
      }
    }

    alert(`Successfully uploaded ${uploadCount} files.`);

    // Clear the input
    if (InputRef.current) {
      InputRef.current.value = "";
      InputRef.current.type = "text";
      InputRef.current.type = "file";
      setSelectedFiles([]);
    }

    // Reset the state
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="container">
      <p>
        Welcome to Zachys Automated Product Attribution. This tool lets you upload a spreadsheet to verify items, find attributes, or locate Zachys SKUs. Simply click the Upload button below to select your completed Attribution Spreadsheet or to upload label images. Our AI will then match your information to the best possible results.
      </p>
      <div className="upload-section">
        <label htmlFor="file-upload" className="upload-label">Select Files</label>
        <input type="file" className="file-input" id="file-upload" onChange={handleFileChange} multiple ref={InputRef} />
        <button className="upload-label" onClick={handleUpload}>Upload</button>
        <div className="selected-files">
          {selectedFiles.length > 0 ? (
            <p><b>Selected Files:</b></p>) : null}
          {selectedFiles.length > 0 ? (
            selectedFiles.map((element, index) => (
              <p key={index}>{element.name}</p>
            ))
          ) : null
          }
        </div>
      </div>
      {isLoading ? (
        <>
          <div className="loading-card" style={{ display: 'flex', justifyContent: 'center' }}>
            <LoadingSpinner />
            <p>Loading, please wait...</p>
          </div>
        </>
      ) : null}
      <p>
        After you upload your files, please allow up to 10 minutes for processing. Once finished, you’ll receive an email with a link to a completed spreadsheet. For worksheet instructions and an uploadable template, please <a href="https://zachys.sharepoint.com/:x:/s/ZachysPMO181/EV61WQfSDVFDuxoW_bIDhxIBztYG04OaqicXP6CR0MSTjg?e=5MVC3Y" target='_blank' download>click here</a>. If you need assistance, please contact <a href="mailto:kjacobs@zachys.com"> kjacobs@zachys.com</a>.
      </p>
    </div>
  );
};

export default FileUpload;